import BaseAPI from 'api/base.api';
import type { AlertFeedbackPayload } from 'types/squares.type';

export default class AlertsAPI extends BaseAPI {
  getAlerts = async (customerId: string) => {
    const response = await this.API.get(
      `squares/notifications/web/${customerId}`,
      {
        customerId,
      }
    );
    return response.data;
  };

  acknowledgeAlert = async (notificationId: string) => {
    const response = await this.API.patch(
      `squares/notifications/${notificationId}/ack`,
      {
        notificationId,
      }
    );
    return response.data;
  };

  submitAlertFeedback = async (
    notificationId: string,
    userFeedback: AlertFeedbackPayload
  ) => {
    const response = await this.API.post(`squares/notifications/feedback`, {
      notificationId,
      userFeedback,
    });

    return response.data;
  };
}
